import Question from './Question'

export { Question }




// WEBPACK FOOTER //
// ./src/question/components/index.js